/** Détecte un type vidéo (enum fichier, contentType API ou MIME). */
export function isVideoContent(contentType?: string | null, fileType?: string | null): boolean {
  if (fileType === 'VIDEO') {
    return true;
  }
  const ct = (contentType ?? '').toUpperCase();
  if (!ct) {
    return false;
  }
  return ct.startsWith('VIDEO_') || ct.includes('VIDEO/');
}

/** Résout le MIME type pour la balise video HTML. */
export function resolveVideoMimeType(contentType?: string | null, mimeType?: string | null): string {
  if (mimeType) {
    return mimeType;
  }
  const map: Record<string, string> = {
    VIDEO_MP4: 'video/mp4',
    VIDEO_AVI: 'video/x-msvideo',
    VIDEO_MOV: 'video/quicktime',
    VIDEO_WMV: 'video/x-ms-wmv',
    VIDEO_FLV: 'video/x-flv',
    VIDEO_WEBM: 'video/webm'
  };
  if (contentType && map[contentType]) {
    return map[contentType];
  }
  const lower = (contentType ?? '').toLowerCase();
  if (lower.includes('webm')) return 'video/webm';
  if (lower.includes('quicktime') || lower.includes('mov')) return 'video/quicktime';
  return 'video/mp4';
}
